var dialogContent = {
    base: {
        outline: "none",
        display: "inline-block",
        boxSizing: "border-box",
        verticalAlign: "middle",
        whiteSpace: "normal",
        textAlign: "left",
    },
    variants: {
        size: {
            lg: {
                maxWidth: "800px",
            },
            md: {
                maxWidth: "600px",
            },
            sm: {
                maxWidth: "400px",
            },
            fullwidth: {
                maxWidth: "100%",
            },
            "content-width": {
                width: "reset",
                maxWidth: "100%",
            },
        },
    },
};
var dialogOverlay = {
    base: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        height: "100dvh",
        boxSizing: "border-box",
        overflow: "auto",
        zIndex: "modal",
        display: "block",
        whiteSpace: "nowrap",
        textAlign: "center",
        // vertical alignment technique from MUI dialog
        "&::after": {
            content: "''",
            display: "inline-block",
            boxSizing: "border-box",
            verticalAlign: "middle",
            height: "100%",
            width: 0,
        },
    },
    variants: {
        tone: {
            black: {
                backgroundColor: "black.overlay",
            },
            white: {
                backgroundColor: "rgba(255, 255, 255, 0.6)",
            },
        },
    },
};
var dialogBody = {
    base: {
        px: "24px",
        borderTop: "1px solid",
        borderBottom: "1px solid",
        borderColor: "black.10",
    },
    variants: {
        tone: {
            lightgrey: {
                backgroundColor: "black.2",
            },
            white: {
                backgroundColor: "white",
            },
        },
    },
};

export { dialogBody, dialogContent, dialogOverlay };
//# sourceMappingURL=dialog.js.map
